/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ChangeEvent, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { getCurrentPrinterName, setPrinter } from '../../modules/common/helper'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

type Props = {
    show: boolean
    mode: string
    data?: any
    onClose: () => void
}

const PrinterNameModal: React.FC<Props> = ({ show, onClose }) => {
    const [printerName, setPrinterName] = useState<string>();

    useEffect(() => {
        if (show) {
            getPrinterName();
        }
    }, [show])

    
    const getPrinterName = () => {
        setPrinterName(getCurrentPrinterName() ?? '')
    }

    const setCurrentPrinterName = (name: string) => {
        setPrinter(name)
        onClose()
    }

    const handleChangePrinterName = (e: ChangeEvent<HTMLInputElement>) => {
        setPrinterName(e.target.value)
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Thiết lập máy in</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
            <form>
                <div className="col-12">
                    <input
                        className='form-control'
                        name='printer_name'
                        placeholder='Nhập tên máy in hóa đơn'
                        value={printerName}
                        onChange={handleChangePrinterName}
                    />
                    <p className='text-danger mt-2 mb-0'><i className='text-danger'>Lưu ý: Cần nhập chính xác tên máy in đã cài đặt </i></p>
                    <Link
                        className="text-underline text-primary d-flex align-items-center"
                        target="__blank"
                        to={toAbsoluteUrl(`/digital-certificate.txt`)} >
                        <i className="bi bi bi-cloud-arrow-down-fill fs-1 text-success me-2"></i> Tải chứng thư (QzTray)
                    </Link>
                </div>
                <div className='d-flex mb-4 justify-content-center pt-8'>
                    <button className="btn btn-bg-secondary mx-1" type="button" onClick={() => onClose()}>Tắt</button>
                    <button className="btn btn-bg-primary mx-1" type="button" onClick={() => setCurrentPrinterName(printerName ?? '')}>Lưu</button>
                </div>
            </form>
            </Modal.Body>
        </Modal>
    )
}

export default PrinterNameModal
